// extracted by mini-css-extract-plugin
export default {"empty-wrap":"XM77vTrfeozABgpaRHIz"};